/**
 * EZUIKit 播放器主题配置
 * 统一关闭工具栏「全局全屏」(expend)，保留「网页全屏」(webExpend)
 */

export function buildPcLiveThemeData (enablePtz, compact) {
    const showMediaBtns = compact ? 0 : 1
    return {
        autoFocus: 5,
        header: {
            color: '#1890ff',
            activeColor: '#FFFFFF',
            backgroundColor: '#000000',
            btnList: [
                { iconId: 'deviceID', part: 'left', defaultActive: 0, memo: '顶部设备名称', isrender: 1 },
                { iconId: 'deviceName', part: 'left', defaultActive: 0, memo: '顶部设备ID', isrender: 1 },
                { iconId: 'cloudRec', part: 'right', defaultActive: 0, memo: '头部云存储回放', isrender: 0 },
                { iconId: 'rec', part: 'right', defaultActive: 0, memo: '头部本地回放', isrender: 0 }
            ]
        },
        footer: {
            color: '#FFFFFF',
            activeColor: '#1890FF',
            backgroundColor: '#00000021',
            btnList: [
                { iconId: 'play', part: 'left', defaultActive: 1, memo: '播放', isrender: 1 },
                { iconId: 'capturePicture', part: 'left', defaultActive: 0, memo: '截屏按钮', isrender: showMediaBtns },
                { iconId: 'sound', part: 'left', defaultActive: 0, memo: '声音按钮', isrender: 1 },
                { iconId: 'pantile', part: 'left', defaultActive: 0, memo: '云台控制按钮', isrender: enablePtz ? 1 : 0 },
                { iconId: 'recordvideo', part: 'left', defaultActive: 0, memo: '录制按钮', isrender: showMediaBtns },
                { iconId: 'talk', part: 'left', defaultActive: 0, memo: '对讲按钮', isrender: showMediaBtns },
                { iconId: 'zoom', part: 'left', defaultActive: 0, memo: '电子放大', isrender: 1 },
                { iconId: 'hd', part: 'right', defaultActive: 0, memo: '清晰度切换按钮', isrender: 1 },
                { iconId: 'webExpend', part: 'right', defaultActive: 0, memo: '网页全屏按钮', isrender: 1 },
                { iconId: 'expend', part: 'right', defaultActive: 0, memo: '全局全屏按钮', isrender: 0 }
            ]
        }
    }
}

/** 回放 pcRec / simple 等模板：仅关闭全局全屏按钮 */
export function buildHideGlobalFullscreenTheme () {
    return {
        footer: {
            btnList: [
                { iconId: 'expend', part: 'right', defaultActive: 0, memo: '全局全屏按钮', isrender: 0 }
            ]
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/ezuikitTheme.js